<template>
  <Flex gap-5 items-center class="px-5 py-1 relative z-20">
    <a
      :href="appDownloadUrl"
      target="_blank"
      rel="noopener noreferrer"
      download="hidro-os.apk"
      class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-50">
      <i class="fa-solid fa-download"></i>
      <span>Baixar APP</span>
    </a>
    <i class="far fa-bell cursor-pointer" @click="hide = !hide"></i>
    <div class="bg-red-500 w-3 h-3 rounded-[500px] absolute top-2 left-7" v-if="notifications.length > 0"></div>
    <div class="size-8 rounded-full bg-gray-200"></div>
    <div>
      <div class="text-xs font-black">{{ user?.name }}</div>
    </div>
    <ChevronY v-model="exit" @click="exit = !exit" bt />
    <TransitionX>
      <Notification v-if="!hide" :notifications="notifications" @readNotification="readNotification" />
    </TransitionX>
    <TransitionX>
      <Card class="absolute w-full top-full left-0" v-if="exit">
        <Button block light @click="logout()">Sair</Button>
      </Card>
    </TransitionX>
  </Flex>
</template>

<script setup>
import { get, update } from '@/crud'
import { baseApiUrl } from '@/global'
import axios from 'axios'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ref, onMounted, computed } from 'vue'

const store = useStore()
const router = useRouter()

const user = computed(() => store.state.user)

const hide = ref(true)
const exit = ref(false)
const notifications = ref([])
const route = 'notification'
const appDownloadUrl = "https://play.google.com/store/apps/details?id=com.softwaresul.hidroosuniversaliza"

const getNotifications = async () => {
  if (user.value && user.value.groupIds) {
    const groupIds = JSON.parse(user.value.groupIds)
    const query = {
      params: {
        filters: [
          {
            column: 'idGroup',
            operator: 'in',
            value: groupIds,
          },
          {
            column: 'readAt',
            operator: 'is',
            value: 'null',
          },
        ],
      },
    }

    const response = await get(route, query)
    notifications.value = response.data
  }
}

const readNotification = async (notification) => {
  const propsToDel = ['deletedAt', 'createdAt', 'updatedAt', 'id']
  const id = notification.id

  for (const prop of propsToDel) {
    delete notification[prop]
  }

  await update(
    route,
    id,
    {
      ...notification,
      readAt: new Date().toISOString().replace('T', ' ').split('.')[0],
    },
    'notificação'
  )

  await getNotifications()
}

const logout = async () => {
  const url = `${baseApiUrl}/logout`
  axios.defaults.withCredentials = true
  localStorage.clear()

  try {
    await axios.post(url)
    localStorage.setItem('user', null)
    store.dispatch('setUser', null)
    router.push('/login')
  } catch (err) {
    console.log(err)
    return err
  }
}

onMounted(async () => {
  await getNotifications()
})
</script>

<style></style>
